import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Usuario } from 'src/app/models/usuario';
import { Router } from '@angular/router';
import { UsuarioService } from 'src/app/shared/usuario.service';
import { AuthService } from 'src/app/shared/auth.service';

@Injectable()
export class InterceptorService implements HttpInterceptor {
  usuarioLogeado = new Usuario();

  constructor(private router: Router, public authService: AuthService) {
    // Puedes inyectar cualquier servicio o dependencia adicional aquí
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/user/login']);

      return next.handle(req);
    }

    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"));

    const alreadyHasAuthorization = req.headers.has('Authorization');
    if (this.usuarioLogeado && !alreadyHasAuthorization) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.usuarioLogeado?.token}`,
        },
      });
    }

    return next.handle(req);

    // if(this.usuarioLogeado == null){
    //   localStorage.clear();
    //   this.router.navigate(['/user/login']).then(() => {
    //     window.location.reload();
    //   });
    // }


    // Para continuar con la cadena de interceptors y enviar la solicitud al servidor, llama a next.handle()
    //return next.handle(req);
  }
}
